define('pages/app/AppController',[
    'jquery',
    'core/can',
    'moment',
    'models/Session',
    'pages/app/NotificationController',
    'components/MainAlert/MainAlertComponent',
    'core/oidc-configuration',
    'template!pages/app/AppView.stache',
    'text!content/js/Enums.json',
    'models/Credential',
    'core/components',
    'core/helpers',
    'bootstrap'
], function ($, can, moment, Session, NotificationController, MainAlertComponent, OidcConfig, template, constants, Credentials) {
    constants = $.parseJSON(constants);
    function pageModule(page) {
        var capped = page.charAt(0).toUpperCase() + page.slice(1);
        return 'pages/' + page + '/' + capped + 'Controller';
    }

    return can.Control.extend({

        defaults: {
            home: 'dashboard',
            mousemoveTimer: undefined,
        }

    }, {
            init: function (el, options) {
                var self = this,
                    scope = this.scope = new can.Map({
                        //need to bypass checks
                        showSigninoidc: true,
                        showLegacysession: true,
                        showOidcsession: true,
                        showIdentitysession: true,        
                    }),

                    isAllAccountsView = this.isAllAccountsView = can.compute(function () {
                        var params = Session.filterParams();
                        return Session.attr('_isVendor') && $.isEmptyObject(params);
                    });

                    // Render
                    el.html(can.view(template, scope));
                    this.main = el.find('#App__Main'); // TODO load menu settings, update from permissions

                    // Load Page
                    var page = can.route.attr('page');
                    if (page) {
                        if (this.hasAuthorization(page)) {
                            this.loadPage(page);
                        }
                    } else {
                        // Start Router
                        can.route.attr('page', options.home);
                    }

                // ---------------------------------------------
                // Handling Session Expiry
                // ---------------------------------------------

                // On any keydown reset the idle expiry time
                $(window).keydown(function (event) {
                    self.resetIdleTime(self, event);
                });

                var IsIdleWarningOpen = false;
                setInterval(function () {
                    var idleTime = JSON.parse(localStorage.getItem('idleExpiry')),
                        a = moment(idleTime),
                        b = moment(),
                        difference = a.diff(b, "s");

                    if (difference > 0) {
                        if (difference <= Session.attr('idleWarningTime') * 60) {
                            if (!IsIdleWarningOpen) {
                                self.alert({
                                    title: 'Are you still there?',
                                    message: 'You have been idle for a while. For security reasons, your session will expire in',
                                    showTimer: true,
                                    buttonText: 'Stay Logged In',
                                    ok: function () {
                                        Session.resetIdleExpiryTime();
                                        IsIdleWarningOpen = false;
                                    }
                                });
                                IsIdleWarningOpen = true;
                            }
                            // Handling multiple tabs session expiration:
                            // Set the Warning alert open to false if the difference is greater than the idleWarningTime
                            // This will let the alert to reopen if the user clicked "Stay Logged in" in another tab
                        } else {
                            IsIdleWarningOpen = false;
                        }
                    }
                }, 1000); // 1 second

                Session.bind('change', function (ev, attr, how, val) {
                    if (typeof val === 'boolean') {
                        if (val) {
                            val = 'True';
                        } else {
                            val = 'False';
                        }
                    }
                    Session.editDataInStorage(attr, val);
                });

            },
            loadSession: function (el, options) {
                var self = this,
                    dashboardPermission = self.isActionAllowed('EftsReport')
                        || self.isActionAllowed('ClaimsReport')
                        || self.isActionAllowed('EligibilityReport'),
                    scope = this.scope
                    scope.attr({
                        currentYear: moment().format('YYYY'),
                        name: Session.attr('_FullName'),
                        showDashboard: dashboardPermission,
                        showClaims: self.isActionAllowed('ClaimsRead'),
                        showPatients: self.isActionAllowed('PatientsRead'),
                        showEligibility: self.isActionAllowed('EligibilityRead'),
                        showReports: dashboardPermission,
                        showAdmin: self.isActionAllowed('UsersRead')
                            || self.isActionAllowed('CredentialsRead')
                            || self.isActionAllowed('ProvidersRead'),
                        showSigninoidc: true, //need to bypass checks
                        blackScreenLink: 'https://blackscreen.axxessweb.com?access_token=' + Session.attr('Token'),
                        isSuperUser: Session.attr('userPermission') & constants.UserPermissions.superUser === constants.UserPermissions.superUser,
                        isImpersonating: can.compute(function () {
                            return Session.attr('isImpersonating');
                        }),
                        isAuthorizedBiller: can.compute(function () {
                            return Session.attr('isAuthorizedBiller');
                        }),
                        toggleImpersonator: function () {
                            Session.attr('isImpersonating', !Session.attr('isImpersonating'));
                            if (!Session.attr('isImpersonating')) {
                                Session.attr('isAuthorizedBiller', false);
                            }
                        },

                        toggleAuthBiller: function () {
                            Session.attr('isAuthorizedBiller', !Session.attr('isAuthorizedBiller'));
                            if (Session.attr('isAuthorizedBiller')) {
                                Session.attr('isImpersonating', true);
                            }
                        },
                        mailTo: can.compute(function () {
                            var message = 'mailto:&body=Hello,%0D%0A%0D%0AI encountered the following bug in AxxessDDE.%0D%0A%0D%0AImpersonator Id: {impersonatorId}%0D%0AUser Id: {userId}%0D%0A',
                                provider = Session.attr('Providers.0'),
                                params = {
                                    impersonatorId: Session.attr('repLoginId'),
                                    userId: Session.attr('UserId')
                                },
                                page = can.route.attr('page');
                            if (provider) {
                                if (!Session.attr('_isVendor')) {
                                    message += 'Provider Name: {providerName}%0D%0AProvider Id: {providerId}%0D%0ANPI: {npi}%0D%0A%0D%0A';
                                    can.extend(params, {
                                        providerName: provider.attr('Name').replace("&", "%26"),
                                        providerId: provider.attr('_id'),
                                        npi: provider.attr('Npi')
                                    });
                                } else {
                                    message += 'Provider Name: %0D%0AProvider Id: %0D%0ANPI: %0D%0A%0D%0A';
                                }
    
                                if (page === 'claim') {
                                    message += 'Claim Id: {id}%0D%0A';
                                    params['id'] = can.route.attr('id');
                                } else if (page === 'patient') {
                                    message += 'Patient Id: {id}%0D%0A';
                                    params['id'] = can.route.attr('id');
                                }
    
                                message += 'Problem: ';
                                message = can.sub(message, params);
    
                                return message;
                            }
                            
                            return "";
                        })
                    }),

                    trialExpDate = Session.attr('trialExpirationDate') || '';

                    // If user has never logged in before and is not impersonating
                    if (Session.attr('LastLogin') === '' && !Session.attr('isImpersonating')) {
                        this.loadModal('modals/welcome/WelcomeModal');
                    }
                    // Dark Day 
                    else if (Session.attr('isDarkDay')) {
                        // On dark days, show the dark day modal everytime the user logs in.				
                        var darkDayCookie = 'isDarkDay' + moment().format('YYYYMMDD');

                        if ($.cookie(darkDayCookie) === undefined) {
                            $.cookie(darkDayCookie, true);
                            this.loadDarkDayModal({
                                ok: function () {
                                    self.checkActiveCredential();
                                }
                            });
                        }

                    }
                    // Trial Expires soon
                    else if (trialExpDate.length > 0) {
                        var formatedTrialExpDate = moment.utc(trialExpDate);

                        if (moment.utc().isBefore(formatedTrialExpDate)) {
                            var trialExpCache = 'trialExp' + moment().format('YYYYMMDD'),
                                modalViewCount = localStorage.getItem(trialExpCache) || 0;

                            if (modalViewCount <= 0) {
                                this.loadModal('modals/trialExp/TrialExpModal');
                                localStorage.setItem(trialExpCache, ++modalViewCount);
                            }
                        }
                    }
                    // Updates
                    else if (!Session.attr('hideMedia')) {
                        this.loadModal('modals/updates/UpdatesModal');
                        this.isIntroClosed = false;
                        if (!Session.attr('isImpersonating')) {
                            Session.attr('hideMedia', true);
                        }
                    }

                    if (!Session.attr('isDarkDay')) {
                        this.checkActiveCredential();
                    }

                    options.home = (function () {
                        var page = options.home;

                        if (!scope.attr('showDashboard')) {
                            if (scope.attr('showClaims')) {
                                page = 'claims';
                            } else if (scope.attr('showPatients')) {
                                page = 'patients';
                            } else if (scope.attr('showEligibility')) {
                                page = 'eligibility';
                            } else if (scope.attr('showReports')) {
                                page = 'reports';
                            } else if (scope.attr('showAdmin')) {
                                page = 'admin';
                            } else {
                                if (page !== 'profile') {
                                    self.denyPermission();
                                    return;
                                }
                            }
                        }

                        return page;
                    })();

                    //Notifications
                    if (Session.attr('Token') !== undefined) {
                        new NotificationController($('#App__Notifications'));
                    }
                    // Load Page
                    var page = can.route.attr('page');

                    if (page && page !== 'dashboard') {

                    } else {
                        // Start Router
                        can.route.attr('page', options.home);
                    }
            },

            // Listens to page parameter change in URL
            '{can.route} page': function (route, ev, page) {
                try {
                    _paq.push(['setDocumentTitle', 'AxxessDDE: ' + page]);
                    _paq.push(['setCustomUrl', window.location.href]);
                    _paq.push(['trackPageView']);
                } catch (err) {
                }
                if (this.hasAuthorization(page)) {
                    this.loadPage(page);
                }
            },

            hasAuthorization: function(page) {
                var allowAnonymous = ['signinoidc', 'legacysession'];
                var allowAccountless = [];
                var allowSessionless = ['identitysession'];

                if (allowAnonymous.includes(page)) {
                    return true;
                }

                var legacyToken = Session.getLegacyTokenFromStorage();
                if (legacyToken) {
                    this.loadPage('legacysession');
                    return false;
                }

                var token = Session.getIdentityTokenFromStorage() || Session.getTokenFromStorage();
                if (!token) {
                    this.loadModal('modals/notLoggedIn/NotLoggedInModal', []);
                    return false;
                }

                if (allowAccountless.includes(page)) {
                    return true;
                }
                
                var accountSelected = Session.getAccountInfo();
                if (!accountSelected) {
                    this.loadModal('modals/switchUser/SwitchUserModal', {
                        title: 'Switch Accounts',
                        canCancel: true
                    });
                    return false;
                }
                
                if (allowSessionless.includes(page)) {
                    return true;
                }
                var session = Session.getTokenFromStorage();
                if (!session) {
                    window.localStorage.setItem('lastUrl', window.location.href);
                    this.loadPage('identitysession');
                    return false;
                }
                //check if hydrated. if not, then hydrate
                if (!Session.attr('Token')) {
                    Session.hydrate(session)
                }
                this.loadSession(this.element, this.options)
                return true;
            },

            checkActiveCredential: function () {
                if (this.isActionAllowed('CredentialsRead') && this.isActionAllowed('CredentialsWrite') && Session.attr('AccountId') != "5519b914d12fb6260ba8d98d") {
                    var self = this;

                    Credentials.findAll().then(function (credentials) {
                        if (!hasValidCredentials(credentials)) {
                            var badCredential = getFirstInvalidCredential(credentials);
                            openCredentialModal(badCredential);
                        }
                    });

                    /**
                     * @param {Credential[]} credentials 
                     */
                    function getFirstInvalidCredential(credentials) {
                        for (var i = 0; i < credentials.length; i++) {
                            var credential = credentials[i];

                            // The agency has one good credential
                            if (!credential._IsActive() || !credential._IsLinked()) {
                                return credential;
                            }
                        }
                    }

                    /**
                     * @param {Credential[]} credentials 
                     */
                    function hasValidCredentials(credentials) {
                        // If they have no credentials
                        if (credentials.length === 0) {
                            return false;
                        }

                        for (var i = 0; i < credentials.length; i++) {
                            var credential = credentials[i];

                            // The agency has one good credential
                            if (credential._IsActive() && credential._IsLinked()) {
                                return true;
                            }
                        }

                        return false;
                    }

                    function openCredentialModal(credential) {
                        self.loadModal('modals/credential/CredentialModal', {
                            lockScreen: {
                                dismissible: false,
                                title: 'Update Credentials',
                                credential: credential
                            }
                        });
                    }
                }

            },


            loadPage: function (page) {
                var self = this,
                    scope = this.scope;
                page = page || this.options.home,
                    check = page,
                    appHeader = this.element.find('#App__Header');

                if (page === 'claim' || page === 'patient') {
                    check += 's';
                }

                if (page !== 'profile' && !scope.attr('show' + can.capitalize(check))) {
                    can.route.attr('page', this.options.home);
                    this.denyPermission(page);
                    return;
                }

                this.loadController(page);
                appHeader.find('.open').removeClass('open');
                appHeader.find('[data-view="' + page + '"]').addClass('open');
            },

            '#BrandTab click': function () {
                can.route.attr({ page: 'dashboard' })
            },

            '.intro-video click': function (el, ev) {
                this.loadModal('modals/video/VideoModal', {
                    isAfterWelcome: el.closest('#WelcomeModal__Modal').length > 0
                });
            },

            '.training-video click': function (el, ev) {
                this.loadModal('modals/video/VideoModal', {
                    title: 'How to use AxxessDDE?',
                    videoUrl: 'https://fast.wistia.net/embed/iframe/8uqnfo86x3?autoPlay=true',
                    isWisitaEmbed: true,
                    isAfterWelcome: el.closest('#WelcomeModal__Modal').length > 0
                });
            },

            // --------------------------------------------------
            // Load Controllers, Pages, Views, Modals
            // --------------------------------------------------

            loadController: function (page, options) {
                var self = this;
                require([pageModule(page)],
                    function (controller) {
                        if (self.main === undefined) {
                            new controller(div, options);
                        }
                        else {
                            // Loaded in DOM?
                            var id = can.capitalize(page) + '__Controller',
                                $c = self.main.find('#' + id);
                            if ($c.length === 0) {

                                // TODO 
                                // Ask for permission to switch, page can have onUnload functionality
                                // Clean up previous view
                                // Cache, etc

                                var div = $('<div>', { id: id, 'class': 'controller listener' });
                                self.main.html(div);
                                new controller(div, options);
                            }
                        }
                    });
            },

            loadModal: function (modalId, options) {
                //if ($('.modal').length === 0) {
                var self = this;
                require([modalId], function (modal) {
                    var id = modalId.split('/').pop(),
                        div = $('<div>', {
                            'id': id + '__Modal',
                            'class': 'modal fade',
                            'tabindex': '-1',
                            'role': 'dialog',
                            'aria-hidden': 'true'
                        });
                    self.element.append(div);
                    new modal(div, options);
                });
                //}
            },

            // --------------------------------------------------
            // Global Events
            // --------------------------------------------------

            event: function (type, params) {
                this.element.find('.listener').trigger(type, params);
            },

            // --------------------------------------------------
            // Loading - full screen takeover and animation
            // --------------------------------------------------

            loading: function (showOrHide) {

                var self = this,
                    screen = $('#screen');
                if (showOrHide !== false) {
                    if (screen.css('display') !== 'block')
                        screen.show().addClass('fadeIn');
                } else {
                    screen
                        .removeClass('fadeIn')
                        .addClass('fadeOut');
                    // Do not delete this
                    // Animation end is not getting triggered even the after the animation (here, fadeOut) ends When the mouse is moving
					/*.on(this.util.onAnimationEnd, function(e) { 
						screen.hide().removeClass('fadeOut').off(self.util.onAnimationEnd)
					})*/
                    // The fadeOut animation ends in a second
                    setTimeout(function () {
                        screen
                            .hide()
                            .removeClass('fadeOut');
                    }, 1000); // 1 second
                }
            },

            // --------------------------------------------------
            // Dialogs
            // --------------------------------------------------

            alert: function (options) {
                this.loadModal('modals/alert/AlertModal', options);
            },

            confirm: function (options) {
                this.loadModal('modals/confirm/ConfirmModal', options);
            },

            loadDarkDayModal: function (options) {
                this.loadModal('modals/darkDay/DarkDayModal', options);
            },

            // -------------------------------------
            // Permissions
            // -------------------------------------

            isActionAllowed: function (action, permission) {
                var userPermission = Session.attr('userPermission'),
                    medicarePermission = Session.attr('medicarePermission'),
                    actionPermission = constants.MedicarePermissions[action];

                if (!isNaN(permission)) {
                    userPermission = permission;
                    medicarePermission = permission;
                }

                if (action === 'SuperUser' || action === 'UsersRead' || action === 'UsersWrite' || action === 'InvoiceReport') {
                    actionPermission = constants.UserPermissions[action];
                    return (userPermission & actionPermission) === actionPermission;
                } else {
                    return (medicarePermission & actionPermission) === actionPermission;
                }

            },

            denyPermission: function (page) {
                var self = this,
                    text = page ? 'access ' + can.capitalize(page) : ' use AxxessDDE';

                if (page === 'server') {
                    text = 'access this feature';
                }

                this.alert({
                    title: 'Permission Denied',
                    message: 'You do not have the permission to ' + text + '. Please contact your administrator.',
                    ok: page ? '' : function () { self.logout(); }
                });
            },

            // --------------------------------------------------
            // Session - Switching Accounts, Logging Out
            // --------------------------------------------------

            // TODO Component or App handler function that appends to dom and fires and cleanup
            '#App__SwitchAccounts click': function (el, ev) {
                this.loadModal('modals/switchUser/SwitchUserModal', {
                    title: 'Switch Accounts',
                    canCancel: true
                });
            },

            '#App__Logout click': function () {
                this.confirm({
                    title: 'Log Out',
                    okText: 'Log Out',
                    ok: can.proxy(this.logout, this)
                });
            },

            'mousemove': function (el, ev) {
                var self = this;
                if (this.mousemoveTimer) {
                    window.clearTimeout(this.mousemoveTimer);
                }
                this.mousemoveTimer = window.setTimeout(function () {
                    self.resetIdleTime(el, ev);
                }, 100);
            },

            'click': 'resetIdleTime',

            resetIdleTime: function (el, ev) {
                var idleTime = JSON.parse(localStorage.getItem('idleExpiry')),
                    a = moment(idleTime),
                    b = moment(),
                    difference = a.diff(b, "s");

                if (difference > Session.attr('idleWarningTime') * 60) {
                    Session.resetIdleExpiryTime();
                }
            },

            logout: function (el, ev) {
                this.destroy();
                window.App = undefined;
                Session.destroy();
            },

            destroy: function () {
                window.localStorage.clear();
                window.sessionStorage.clear();
            },

            // --------------------------------------------------
            // Utilities
            // --------------------------------------------------

            util: {
                onAnimationEnd: 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend'
            },

            // --------------------------------------------------
            // IsReadOnly
            // --------------------------------------------------

            isReadOnly: function () {
                if (Session.attr('isDarkDay')) {
                    this.loadDarkDayModal();
                    return true;
                } else if (Session.attr('isReadOnly') && !Session.attr('isAuthorizedBiller')) { //  Allow if an Axxess user is impersonating.
                    this.loadModal('modals/credential/FreeTrialModal', {
                        subtitle: 'This account is read-only. In order to resubmit this claim, please login with your DDE credentials.'
                    });
                    return true;
                }
                return false;
            }

        });
});
